import React, { useEffect, useState } from "react";
import { Skeleton } from "primereact/skeleton";
import { Link, useNavigate } from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { getAbonneInfo_allRight } from "../../../services/abonne/AbonneRequest";
import {
  getListeForfaitPourOffrir,
  getListeForfaitPourOffrir_allRight,
  getListeForfaitPourOffrir_secure,
} from "../../../services/forfait/ForfaitRequest";
import { ThreeDots } from "react-loader-spinner";

const OffrirForfait = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [loadingListeForfait, setLoadingListeForfait] = useState(true);
  const [loadingForfait, setLoadingForfait] = useState(false);
  const [fetchingData, setFetchingData] = useState(true);
  const [destinaireNumber, setDestinataireNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [listeForfaits, setListeForfaits] = useState([]);
  const [serviceListe, setServiceListe] = useState([
    {
      id: 0,
      volume: "25",
      unite: "GO",
      designation: "SIM & device",
      cout: "25000",
    },
    {
      id: 1,
      volume: "50",
      unite: "GO",
      designation: "SIM & device",
      cout: "25000",
    },
    {
      id: 2,
      volume: "150",
      unite: "GO",
      designation: "SIM & device",
      cout: "25000",
    },
    {
      id: 3,
      volume: "200",
      unite: "GO",
      designation: "SIM & device",
      cout: "25000",
    },
    {
      id: 4,
      volume: "500",
      unite: "GO",
      designation: "SIM & device",
      cout: "25000",
    },
  ]);

  const saveDestinataireNumber = () => {
    setErrorMessage("");
    if (destinaireNumber.length !== 10) {
      setErrorMessage("Entrez un numéro MTN à 10 chiffres");
    } else {
      sessionStorage.setItem("userPhoneNumber", destinaireNumber);
      setLoadingForfait(true);
      getForfaitParNumeroBeneficiaire();
    }
  };

  const getForfaitParNumeroBeneficiaire = () => {
    if (sessionStorage.getItem("token")) {
      getListeForfaitPourOffrir_secure("OFFRIR_FORFAIT", destinaireNumber)
        .then((res) => {
          setLoadingForfait(false);
          setLoadingListeForfait(false);
          setListeForfaits(res.data.donnee);
          document.getElementById("destinataire-btn").click();
        })
        .catch((err) => {
          console.log("api error", err);
          setLoadingForfait(false);
          setLoadingListeForfait(false);
          setErrorMessage("Entrez un numéro MTN à 10 chiffres");
        });
    } else {
      getListeForfaitPourOffrir_allRight("OFFRIR_FORFAIT", destinaireNumber)
        .then((res) => {
          setLoadingForfait(false);
          setLoadingListeForfait(false);
          setListeForfaits(res.data.donnee);
          document.getElementById("destinataire-btn").click();
        })
        .catch((err) => {
          console.log("api error", err);
          setLoadingListeForfait(false);
          setLoadingForfait(false);
          setErrorMessage("Entrez un numéro MTN à 10 chiffres");
        });
    }
  };

  useEffect(() => {
    sessionStorage.removeItem("userPhoneNumber");
    let abonne = JSON.parse(sessionStorage.getItem('user'))

    getAbonneInfo_allRight()
      .then((res) => {
        setFetchingData(false);
        setUser(res.data.donnee);
      })
      .catch((err) => {
        console.log("api error", err);
      });

      if (!destinaireNumber && abonne.motdepasseisactif) {
        console.log('click', abonne)
        document.getElementById("destinataire-btn").click();
      } else {
        console.log('click', abonne)
        document.getElementById("alert-password-inactif").click();
      }
  }, []);

  return (
    <div>
      <div className="w-11/12 xl:w-10/12 mx-auto sm:grid grid-cols-2 justify-items-center lg:grid-cols-3 gap-y-8 sm:gap-x-4">
        <div className="sm:w-[19rem] md:w-80 py-2 bg-black rounded-tl-md rounded-br-md px-4">
          <h2 className="text-white text-sm sm:text-base">Offrir un forfait :</h2>
        </div>
      </div>
      {/* PRODUCTS FOR DESKTOP */}
      <div className="w-11/12 xl:w-10/12 mx-auto hidden sm:grid grid-cols-2 justify-items-center lg:grid-cols-3 gap-y-8 sm:gap-x-4 mt-10 pb-16">
        {listeForfaits.length > 0 && !loadingListeForfait ? (
          listeForfaits.map((item, index) => (
            <Link
              to={`/detail-forfait/${item.id}`}
              className="block"
              key={index}
            >
              <div className="w-[19rem] md:w-80 bg-gray-100 border-4 border-white rounded-2xl w-fit h-20 flex items-center shadow-xl">
                <div className="w-1/3 px-3 h-full rounded-tl-xl rounded-bl-xl flex flex-col items-center justify-center bg-jaune-mtn">
                  {item.volume ? (
                    <p className="text-black text-xl font-bold">
                      {item.volume} {item.unite}
                    </p>
                  ) : (
                    <p className="text-black text-xl font-bold">Illimité</p>
                  )}
                </div>
                <div className="w-2/3 h-full rounded-2xl flex items-center justify-between gap-x-6 bg-transparent p-3">
                  <div>
                    <p className="text-black text-center flex flex-col items-center text-xl font-bold leading-5">
                      {item.cout}
                      <span className="text-sm">FCFA</span>
                    </p>
                  </div>
                  <div className="bg-jaune-mtn w-10 h-10 rounded-full flex items-center justify-center ml-4 cursor-pointer">
                    <KeyboardArrowRightIcon />
                  </div>
                </div>
              </div>
            </Link>
          ))
        ) : listeForfaits.length === 0 && loadingListeForfait ? (
          <>
            <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
          </>
        ) : listeForfaits.length === 0 && !loadingListeForfait ? (
          <div className="flex items-center justify-center">
            <p className="text-center text-xl text-red-500">
              Aucun forfait trouvé
            </p>
          </div>
        ) : null}
      </div>

      {/* PRODUCTS FOR MOBILE */}
      <div className="list-forfait w-11/12 mx-auto mt-10 sm:hidden grid grid-cols-2 gap-y-8 gap-x-2 pb-16 justify-items-center">
        {listeForfaits.length > 0 && !loadingListeForfait ? (
          listeForfaits.map((item, index) => (
            <Link
              to={`/detail-forfait/${item.id}`}
              key={index}
              className="w-full"
            >
              <div className="forfait-mobile w-full rounded-xl shadow-lg border-4 border-white bg-gray-mtn">
                <div className="bg-jaune-mtn rounded-tl-xl rounded-tr-xl py-3">
                  {item.volume ? (
                    <p className="volume-forfait text-black text-2xl text-center font-bold">
                      {item.volume} {item.unite}
                    </p>
                  ) : (
                    <p className="volume-forfait text-black text-2xl text-center font-bold">
                      Illimité
                    </p>
                  )}
                </div>
                <div className="bg-transparent rounded-tl-xl rounded-tr-xl flex items-center justify-evenly py-3">
                  <div>
                    <p className="prix-forfait text-black text-lg text-center font-bold leading-4">
                      {item.cout} <br />
                      <span className="text-xs">FCFA</span>
                    </p>
                  </div>

                  <div className="bg-jaune-mtn w-7 h-7 rounded-full flex items-center justify-center ml-4 cursor-pointer">
                    <KeyboardArrowRightIcon />
                  </div>
                </div>
              </div>
            </Link>
          ))
        ) : listeForfaits.length === 0 && loadingListeForfait ? (
          <>
            <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
            <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
          </>
        ) : listeForfaits.length === 0 && !loadingListeForfait ? (
          <div className="flex items-center justify-center">
            <p className="text-center text-xl text-red-500">
              Aucun forfait trouvé
            </p>
          </div>
        ) : null}
      </div>

      <label
        htmlFor="destinaire-number"
        id="destinataire-btn"
        className="hidden"
      >
        open modal
      </label>

      {/* MODAL FOR USER NUMBER */}
      <input type="checkbox" id="destinaire-number" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box rounded-lg relative">
          <label
            htmlFor="destinaire-number"
            id="reject-btn"
            className="btn btn-sm btn-circle absolute right-2 top-2"
            onClick={() => navigate("/forfaits/acheter")}
          >
            ✕
          </label>
          <h3 className="text-lg font-bold text-center">
            Entrer le numéro du bénéficiaire
          </h3>
          <div className="py-4">
            <label className="label">
              <span className="label-text">Numéro bénéficiaire</span>
            </label>
            <input
              type="number"
              value={destinaireNumber}
              onChange={(e) => setDestinataireNumber(e.target.value)}
              placeholder="Ex: 0572443712"
              className="input input-bordered w-full"
            />
          </div>
          <div className="flex items-center gap-x-5">
            <button
              disabled={loadingForfait}
              className="w-full h-11 rounded-lg bg-gray-300 font-bold text-black"
              onClick={() => document.getElementById("reject-btn").click()}
            >
              Annuler
            </button>
            <button
              disabled={loadingForfait}
              className="w-full h-11 rounded-lg bg-jaune-mtn font-bold text-black flex items-center justify-center"
              onClick={saveDestinataireNumber}
            >
              {!loadingForfait ? (
                "Valider"
              ) : (
                <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={loadingForfait}
                />
              )}
            </button>
          </div>
          {errorMessage ? (
            <div className="mt-5">
              <p className="font-bold text-red-500 text-center">
                {errorMessage}
              </p>
            </div>
          ) : null}
        </div>
      </div>

      {/* MODAL ALERT ACTIVATION MOT DE PASSE */}
      <input
        type="checkbox"
        id="alert-password-inactif"
        className="modal-toggle"
      />
      <div className="modal">
        <div className="modal-box rounded-lg relative">
          <h3 className="text-lg font-bold text-center">Mot de passe requis</h3>
          <div className="py-4">
            <p className="text-center text-red-500">
              Pour effectuer cette action veuillez activer l'option{" "}
              <span className="font-bold">mot de passe </span>
              dans le menu "profil"
            </p>
          </div>
          <div className="flex items-center gap-x-5 mt-3">
            <button
              className="w-full h-11 rounded-lg bg-gray-300 font-bold text-black"
              onClick={() => navigate("/forfaits/acheter")}
            >
              Retour
            </button>
            <button
              className="w-full h-11 rounded-lg bg-jaune-mtn font-bold text-black"
              onClick={() => navigate("/compte/profil")}
            >
              Activer
            </button>
          </div>
        </div>
      </div>

      <div className="w-11/12 xl:w-9/12 mx-auto mt-10 pb-16">
        <div className="sm:w-[19rem] md:w-80 py-2 bg-black rounded-tl-md rounded-br-md px-4">
          <h2 className="text-white text-sm sm:text-base">Votre compte :</h2>
        </div>
        <div className="w-full h-fit mt-10 px-4 md:px-8 py-5 rounded-tl-3xl rounded-br-3xl bg-white border-2 border-black">
          <div className="account-detail">
            <div className="detail-item flex items-start">
              <p className="text-sm sm:text-base md:text-lg pb-3 w-2/4 lg:w-1/3">Numéro :</p>
              <p className="text-sm sm:text-base md:text-lg font-bold w-2/4 pb-1">
                {user ? user.numero : "..."}
              </p>
            </div>
            <div className="detail-item flex items-start">
              <p className="text-sm sm:text-base md:text-lg pb-3 w-2/4 lg:w-1/3">
                Crédit de communication :
              </p>
              <p className="text-sm sm:text-base md:text-lg font-bold w-2/4 pb-1">
                {user ? user.Solde : "..."} FCFA
              </p>
            </div>
            {/* <div className="detail-item flex items-start">
              <p className="text-sm sm:text-base md:text-lg pb-3 w-2/4 lg:w-1/3">
                Volume internet disponible :
              </p>
              <p className="text-sm sm:text-base md:text-lg font-bold w-2/4 pb-1">
                XXXXX MO <span>valable jusqu'au</span> 12-03-2023
              </p>
            </div>
            <div className="detail-item flex items-start">
              <p className="text-sm sm:text-base md:text-lg pb-3 w-2/4 lg:w-1/3">
                Service(s) MTN Play actif(s) :
              </p>
              <p className="text-sm sm:text-base md:text-lg font-bold w-2/4 pb-1">XXXXXX</p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OffrirForfait;
